"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backgroundSymbols = exports.foregroundSymbols = void 0;
exports.foregroundSymbols = [
    {
        "url": "https://static.arcgis.com/images/Symbols/Firefly/FireflyB17.png",
        "type": "picture-marker",
        "height": 15,
        "width": 15,
    },
    {
        "url": "https://static.arcgis.com/images/Symbols/Firefly/FireflyB17.png",
        "type": "picture-marker",
        "height": 25,
        "width": 25,
    },
    {
        "url": "https://static.arcgis.com/images/Symbols/Firefly/FireflyB17.png",
        "type": "picture-marker",
        "height": 35,
        "width": 35,
    },
    {
        "url": "https://static.arcgis.com/images/Symbols/Firefly/FireflyB17.png",
        "type": "picture-marker",
        "height": 45,
        "width": 45,
    },
    {
        "url": "https://static.arcgis.com/images/Symbols/Firefly/FireflyB17.png",
        "type": "picture-marker",
        "height": 55,
        "width": 55,
    },
];
exports.backgroundSymbols = [
    {
        "url": "https://static.arcgis.com/images/Symbols/Firefly/FireflyC1.png",
        "type": "picture-marker",
        "height": 25,
        "width": 25,
    },
    {
        "url": "https://static.arcgis.com/images/Symbols/Firefly/FireflyC1.png",
        "type": "picture-marker",
        "height": 35,
        "width": 35,
    },
    {
        "url": "https://static.arcgis.com/images/Symbols/Firefly/FireflyC1.png",
        "type": "picture-marker",
        "height": 45,
        "width": 45,
    },
    {
        "url": "https://static.arcgis.com/images/Symbols/Firefly/FireflyC1.png",
        "type": "picture-marker",
        "height": 55,
        "width": 55,
    },
    {
        "url": "https://static.arcgis.com/images/Symbols/Firefly/FireflyC1.png",
        "type": "picture-marker",
        "height": 65,
        "width": 65,
    },
];
